import { twMerge } from "tailwind-merge";

import { faFolderPlus } from "@fortawesome/free-solid-svg-icons/faFolderPlus";

import CustomCard from "components/CustomCard";
import FontAwesomeIcon from "components/FontAwesomeIcon";

const EmptyFollowedCollections = ({
  style = "card",
}: {
  style?: "card" | "cardV2";
}) => {
  if (style === "cardV2") {
    return (
      <div className={twMerge("my-0", "flex")}>
        <CustomCard
          className={twMerge(
            "w-[144px] h-[112px]",
            "md:w-[184px] md:h-[144px]",
            "flex flex-col items-center justify-center",
            "mb-0 p-0 px-[42px]"
          )}
        >
          <FontAwesomeIcon
            icon={faFolderPlus}
            className={twMerge("text-[51px] md:text-[100px] text-shady-gray")}
          />
        </CustomCard>
        <div
          className={twMerge(
            "ml-[14px] md:ml-[32px]",
            "text-[14px] md:text-[18px]",
            "text-intelligent-silver",
            "flex items-center"
          )}
        >
          Quick access to your favourite Collections.
          <br />
          Collections you follow will be displayed here.
        </div>
      </div>
    );
  }

  return (
    <div className={twMerge("mt-[16px] mb-[25px]", "flex")}>
      <CustomCard
        className={twMerge(
          "w-[144px] h-[112px]",
          "md:w-[288px] md:h-[216px]",
          "flex flex-col items-center justify-center",
          "mb-0 p-0 px-[42px]"
        )}
      >
        <FontAwesomeIcon
          icon={faFolderPlus}
          className={twMerge("text-[51px] md:text-[100px] text-shady-gray")}
        />
      </CustomCard>
      <div
        className={twMerge(
          "ml-[14px] md:ml-[32px]",
          "text-[14px] md:text-[24px]",
          "text-intelligent-silver",
          "flex items-center"
        )}
      >
        Quick access to your favourite Collections.
        <br />
        <br />
        Collections you follow will be displayed here.
      </div>
    </div>
  );
};

export default EmptyFollowedCollections;
